import React from "react";
import withExplorerPropTypesLogic from "../hoc/property-types/withExplorerPropTypesLogic";
import PropTypesFilterBase from "../base/PropTypeFilterBase";

const FilterComponent = withExplorerPropTypesLogic(PropTypesFilterBase);
const ExplorerPropTypesFilter = React.memo(FilterComponent);

export default ExplorerPropTypesFilter;